export class ContactDTO {
    constructor(
        public firstName: string | null,
        public lastName: string | null,
        public emailAddress: string | null,
        public phoneNumber: string | null
    ) {
    }
}
